import Link from "next/link";
import { useTranslation } from "next-i18next";

import { Text } from "@/components/elements";
import { LINKS } from "@/constants/links";

import footer from "../footer.module.css";

const ShopLinks = [
  {
    href: LINKS.SHOP_SOAP,
    key: "navigation.category.soap",
  },
  {
    href: LINKS.SHOP_CLEANING,
    key: "navigation.category.cleaning",
  },
  {
    href: LINKS.SHOP_LAUNDRY,
    key: "navigation.category.laundry",
  },
  {
    href: LINKS.SHOP,
    key: "navigation.products",
  },
];

const InfoLinks = [
  {
    href: LINKS.WHAT_IS_PAFYLL,
    key: "navigation.what",
  },
  {
    href: LINKS.INSPIRATION,
    key: "navigation.articles",
  },
  {
    href: LINKS.FAQ,
    key: "navigation.faq",
  },
  {
    href: LINKS.CONTACT_US,
    key: "navigation.contact",
  },
];

const TermsLinks = [
  {
    href: LINKS.PRIVACY,
    key: "navigation.privacy",
  },
  {
    href: LINKS.TERMS,
    key: "navigation.service",
  },
];

const List = ({ title, list, t }) => {
  return (
    <>
      <li>
        <Text as="h4">{t(`navigation.${title}`)}</Text>
        <ul className={footer.child_list}>
          {list.map(({ href, key }) => (
            <li key={key}>
              <Link href={href}>{t(key)}</Link>
            </li>
          ))}
        </ul>
      </li>
    </>
  );
};

export const Navigation = () => {
  const { t } = useTranslation("footer");

  return (
    <nav className={footer.nav}>
      <ul className={footer.parent_list}>
        <List title="shop" list={ShopLinks} t={t} />
        <List title="about" list={InfoLinks} t={t} />
        <List title="terms" list={TermsLinks} t={t} />
      </ul>
    </nav>
  );
};
